import { NextApiRequest, NextApiResponse } from 'next';

// Generate a unique token for your app - store this securely
export const APP_SECRET_TOKEN = process.env.PUBLIC_API_SECRET || 'secret123';

// Custom header name
export const CUSTOM_HEADER = 'x-app-token';

/**
 * Middleware to verify requests are coming from your Next.js app
 */
export function verifyInternalRequest(
  req: NextApiRequest,
  res: NextApiResponse,
  next: () => void
) {
  const token = req.headers[CUSTOM_HEADER];
  
  // Check if the custom header exists and matches
  if (!token || token !== APP_SECRET_TOKEN) {
    return res.status(403).json({ 
      error: 'Forbidden',
      message: 'Access denied. This API can only be accessed from the application.' 
    });
  }
  
  // Additional check: verify referer is from same origin (optional but recommended)
  const referer = req.headers.referer || req.headers.origin;
  const host = req.headers.host;
  
  if (referer && host && !referer.includes(host)) {
    return res.status(403).json({ 
      error: 'Forbidden',
      message: 'Invalid request origin.' 
    });
  }
  
  next();
}

/**
 * Higher-order function to wrap API routes with security
 */
export function withInternalAuth(handler: (req: NextApiRequest, res: NextApiResponse) => Promise<void>) {
  return async (req: NextApiRequest, res: NextApiResponse) => {
    const token = req.headers[CUSTOM_HEADER];
    
    if (!token || token !== APP_SECRET_TOKEN) {
      return res.status(403).json({ 
        error: 'Forbidden',
        message: 'Access denied. This API can only be accessed from the application.' 
      });
    }
    
    return handler(req, res);
  };
}
